import { map } from 'lodash';
import { IModel, IntakePetSectionQuestionModel, Model } from '.';

export interface IIntakePetSection extends IModel {
    intakePetSectionId: number;
    intakePetId: number;
    sectionId: number;
    name: string;
    displayName: string;
    sortOrder: number;
    questions: IntakePetSectionQuestionModel[];
}

export class IntakePetSection extends Model implements IIntakePetSection {
    intakePetSectionId: number;
    intakePetId: number;
    sectionId: number;
    name: string;
    displayName: string;
    sortOrder: number;
    questions: IntakePetSectionQuestionModel[] = [];

    constructor(params: Partial<IIntakePetSection> = {}) {
        const {
            intakePetSectionId = 0,
            intakePetId = 0,
            sectionId = 0,
            name = '',
            displayName = '',
            sortOrder = 0,
            questions = [] as Array<IntakePetSectionQuestionModel>,
        } = params;
        super(params);
        this.intakePetSectionId = intakePetSectionId;
        this.intakePetId = intakePetId;
        this.sectionId = sectionId;
        this.name = name;
        this.displayName = displayName;
        this.sortOrder = sortOrder;
        map(questions, (question) => { this.questions.push(new IntakePetSectionQuestionModel(question)); });
    }
}
